export const initialize = {
  basket: []
};

const reducerBusiness = (state, action) => {
  switch (action.type) {
    case "Agenda_Service":
      return {
        ...state,
        basket: [...state.basket, { ...action.item, quantity: action.item.quantity || 1 }]
      };

    case "Increase_Service_BASKET":
      return {
        ...state,
        basket: state.basket.map(item =>
          item.id === action.item.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      };

    case "Decrease_Service_BASKET":
      return {
        ...state,
        basket: state.basket.map(item =>
          item.id === action.item.id && item.quantity > 1
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      };

    case "REM_SERVICE_FROM_BASKET":
      return {
        ...state,
        basket: state.basket.filter(item => item.id !== action.item.id)
      };

    default:
      return state;
  }
};

export default reducerBusiness;
